module.exports = __webpack_public_path__ + "img/share_bg.6f706e4f.png";